<template>
  <div >
    <v-dialog v-model="orderDialog" width="90%" @input="v => v || closeDialog()">
      <!--<v-dialog v-model="dialog2" width="80%" style="overflow:auto;-webkit-overflow-scrolling:touch">-->
      <v-flex v-if="this.deliveryNumbers.length <= 0" style="background-color: white" pa-4  text-xs-center>
            <span class="subheading">
              검색한 이력이 없습니다
            </span>

      </v-flex>
      <v-layout v-else column>
        <v-list two-line>
          <template v-for="(item, index) in deliveryNumbers">
            <v-list-tile
              :key="index"
              avatar
              @click="{}"
            >
              <v-list-tile-content
                @click="clickDeliveryNumberPopup(item)"
              >
                <v-list-tile-title v-html="item.deliveryNumber"></v-list-tile-title>
                <v-list-tile-sub-title v-html="item.description"></v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-btn icon ripple @click="removeDeliveryNumber(item)">
                  <v-icon color="grey lighten-1">mdi-minus-circle</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
            <v-divider v-if="index + 1 < deliveryNumbers.length" :key="`divider-${index}`"></v-divider>
          </template>
        </v-list>
        <!--<v-btn @click="closeDialog">-->
        <!--CLOSE-->
        <!--</v-btn>-->
        <!--<template v-for="(item, index) in deliveryNumbers">-->
        <!--<v-flex :key="index" pa-4>-->
        <!--<v-card>-->
        <!--<span class="subheading">{{ item }}</span>-->
        <!--</v-card>-->
        <!--</v-flex>-->
        <!--</template>-->
      </v-layout>
    </v-dialog>
  </div>
</template>
<script>
import EventBus from '@/common/EventBus'

export default {
  data () {
    return {
      orderDialog: true,
      deliveryNumbers: []
    }
  },
  methods: {
    closeDialog: function () {
      this.$router.history.go(-1)
      this.orderDialog = false
    },
    clickDeliveryNumberPopup: function (node) {
      EventBus.$emit('clickDeliveryNumberPopup', node)
      this.$router.history.go(-1)
    },
    removeDeliveryNumber: function (node) {
      this.deliveryNumbers = this.deliveryNumbers.filter((it) => {
        return it.deliveryNumber !== node.deliveryNumber
      })
      this.$cookie.set('deliveryNumbers', JSON.stringify(this.deliveryNumbers), { expires: '1Y' })
      EventBus.$emit('updateDeliveryNumbers', this.deliveryNumbers)
    }
  },
  created () {
    if (this.$route.params.deliveryNumber === undefined) {
      // press F5
      this.deliveryNumbers = this.$cookie.get('deliveryNumbers') === null ? [] : JSON.parse(this.$cookie.get('deliveryNumbers'))
    } else {
      this.deliveryNumbers = this.$route.params.deliveryNumbers
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modal/HistoryModal.vue